import React from "react"
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import StaticExpander from '../components/Material-UI-Components/StaticExpander.js';
import Layout from '../components/layout'
import SEO from "../components/seo"
import ContactForm from '../components/Custom Modules/ContactForm';

/* importing json files */
import AdolescentSpecificServicesJSON from '../components/Page-Data/AdolescentSpecificServices.json';

/* importing images */
import Logo from '../images/Adolescent/logo.png';

const AdolescentSpecificServices = () => (
  <Layout>
    <SEO 
      title="Best Adolescent Counselling and Adolescent Counsellers in India at Pratiiti.com" 
      description="Adolescent Counselling-Pratiiti.com provide you qualified counsellors for Adolescent counselling at affordable rates."
      canonical={"https://wwww.pratiiti.in/adolescent-specific-services"}
    />
    <div>
      <Grid xs={12} md={6} sm={3}>
        <div className="logo">
          <img src={Logo} alt="Adolescent logo"/>
        </div>
      </Grid>
        <StaticExpander
            data = {AdolescentSpecificServicesJSON}
        />
	  </div>
    <ContactForm/>
  </Layout>
)

export default AdolescentSpecificServices
